export const DEFAULT_POLL_INTERVAL = 100;
export const DEFAULT_CONCURRENCY = 1;
export const DEFAULT_WARN_AT_O = 100;
export const DEFAULT_BATCH_POLLING_TIMEOUT = 100;
export const DEFAULT_ERROR_MESSAGE = "An unknown error occurred";
export const MAX_RETRIES = 3;
